import {http} from './config/config-relation-register'

export default{
    listar:async(token)=>{
        return  http.get('estados',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('estados',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('estados/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('estados/'+item.id_estado,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}